import { get, post } from '@/utils/request'
const productApi = {
  /* 直充业务-商品管理-添加或编辑（如果是编辑则需要传ID参数） */
  saveForm: function(params) {
    return post('/recharge/product/save-update', params)
  },
  /* 直充业务-商品管理-批量修改价格 */
  batchPrice: function(params) {
    return post('/recharge/product/save-update-batch', params)
  },
  /* 直充业务-商品管理-添加或编辑初始化（如果是编辑则需要传ID参数，会根据ID返回相应信息, 编号只显示，不能添加和编辑。如果是添加操作也可以不请求该接口方法。查看信息也可以使用该接口方法） */
  getInit(id) {
    return get('/recharge/product/save-update-init', { id })
  },
  /* 商品管理-修改状态 */
  updateStatus: function(params) {
    return post('/recharge/product/update-status', {
      id: params.id,
      productStatus: params.productStatus,
    })
  },
  /* 直充业务-商品管理，获取所有（在需要选择直充业务商品的地方可以使用） */
  getAll: function(data) {
    return get('/recharge/product/list-all', data || {})
  },
  /* 关联供货 */
  relationPro: function(params) {
    return post('/recharge/product/cognate', {
      ...params,
    })
  },
  /* 查询关联代理商 */
  relationAgent: function(data) {
    return get('/recharge/product/agentMember', data || {})
  },
  /* 保存自定义价格 */
  saveAgentPrice: function(params) {
    return post('/recharge/product/agentPrice', {
      ...params,
    })
  },
  /* 直充业务-商品管理-批量操作 */
  batchDeal: function(params) {
    return post('/recharge/product/batch', {
      ...params,
    })
  },
}

export default productApi



// WEBPACK FOOTER //
// ./src/api/product.js